/**
 * Game System Adapter
 *
 * The interface between Machina's generic core and a specific game system's
 * rules engine. System plugins (e.g. @machina/system-dnd5e) implement this
 * interface to provide character creation, dice resolution, combat, magic,
 * and encounter balance for their system.
 *
 * Not all systems have all features. Narrative systems like Fate may skip
 * combat entirely. The adapter makes everything optional except identity
 * and the core resolution mechanic.
 */
// =============================================================================
// SYSTEM REGISTRY
// =============================================================================
/** In-memory registry of loaded game system adapters */
const systemRegistry = new Map();
/** Currently active game system ID */
let activeSystemId = null;
/** Register a game system adapter */
export function registerSystem(adapter) {
    systemRegistry.set(adapter.id, adapter);
}
/** Get a registered game system adapter */
export function getSystem(systemId) {
    return systemRegistry.get(systemId);
}
/** Get all registered system IDs */
export function getRegisteredSystems() {
    return Array.from(systemRegistry.keys());
}
/** Check if a system is registered */
export function hasSystem(systemId) {
    return systemRegistry.has(systemId);
}
/** Get the currently active system ID */
export function getActiveSystemId() {
    return activeSystemId;
}
/** Get the currently active game system adapter */
export function getActiveSystem() {
    if (!activeSystemId)
        return undefined;
    return systemRegistry.get(activeSystemId);
}
/** Set the active game system. Returns the adapter if found, undefined otherwise. */
export function setActiveSystem(systemId) {
    const adapter = systemRegistry.get(systemId);
    if (adapter) {
        activeSystemId = systemId;
    }
    return adapter;
}
//# sourceMappingURL=system-adapter.js.map